<template>
  <div>
    <NavBar v-bind:displayLogo="false" v-bind:displayUser="true"></NavBar>
    <div class="container-fluid">
      <div class="row">
        <div class="col col-12">
          <div v-show="mostrar" id="postulantes"></div>

          <button
            type="button"
            @click="loadOldGeneralData"
            class="btn btn-outline-primary"
            hidden="hidden"
            id="btn-load-old-data"
          >
            Cargar datos de una convocatoria anterior
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from "@component-basic/NavBar.vue";
import { Form } from "vue-formio";
import { Formio } from "formiojs";
import { config } from "@/formio/config";
import utils from "formiojs/utils";
import { lan_es } from "../../utils/translations";

export default {
    metaInfo: {},
    components: {
        NavBar,
        formio: Form,
    },
    data() {
        return {
            components: null,
            formulario_real: null,
            formulario: null,
            pageAct: 0,
            pageList: null,
            mostrar: false,
            flag: "false",
            oldSubmission: {},
            actualSubmission: null,
            activeConvocatoria: null,
            convocatoriaAnterior: null,
            roles: {
                "5dc44c1b1c9d4400000b5fc5": "galeria",
                "5e151a271c9d44000074b832": "fundacion",
                "5e151a3f1c9d44000074b833": "museo",
                "5e151a5f1c9d44000074b834": "autogestionado",
                "5e151af71c9d44000074b835": "institucion",
                "673b90a83ee1fe2b164c333e": "diseno",
            },
        };
    },
    mounted() {
        var datos = localStorage.getItem("formioUser");
        var json = JSON.parse(datos);
        let rol = this.roles[json.roles[0]];
        localStorage.setItem("formrol", rol);
        var that = this;
        $(document).on("click", "ul.pagination >li.page-item", function () {
            var r = /\d+/;
            var act = $(this).children().text();
            act = act.match(r);
            that.pageAct = act == null ? 0 : parseInt(act[0]);
            that.toggleShowButton(that.pageAct);
            var finalizado = 0;
            that.pageList.forEach(function (value, i) {
                if (value.status) {
                    let elements = document.querySelectorAll(".red-status");
                    elements.forEach((number) => {
                        if (parseInt(number.innerText) == i) {
                            number.className = number.className.replace("red", "green");
                            if (document.querySelectorAll("#verify-" + i).length != 0) {
                                document.getElementById("verify-" + i).innerHTML = "Sección completada";
                            }
                        }
                    });
                    finalizado++;
                } else {
                    if (document.querySelectorAll("#verify-" + i).length != 0){
                        document.getElementById("verify-" + i).innerHTML = "Aún hay información por diligenciar";
                    }
                }
            });

            if (finalizado == that.pageList.length - 2) {
                let elements = document.querySelectorAll(".red-status");
                elements.forEach((number) => {
                    if (parseInt(number.innerText) == that.pageList.length - 1) {
                        number.className = number.className.replace("red", "green");
                        if (document.getElementsByClassName("btn-wizard-nav-submit").length > 0){
                            document.getElementsByClassName("btn-wizard-nav-submit")[0].style.display = "inline-block";
                        }
                    }
                });
            } else {
                if (document.getElementsByClassName("btn-wizard-nav-submit").length > 0){
                    document.getElementsByClassName("btn-wizard-nav-submit")[0].style.display = "none";
                }
            }
        });
    },
    created: async function () {
        let context = this;
        var lenguaje = localStorage.getItem("lang");
        var form = lenguaje === "en" ? new Formio(config.forms.formulario_en) : new Formio(config.forms.formulario_es);
        var formio = new Formio(config.forms.formulario);
        let panfinal = [];
        let componente = await form.loadForm().then(async function (formio) {
            var count = 0;
            let flag = "false";
            var content = "<div class='row'><p style='width: 100%; background-color: #ABA9AA; color:white;' class='text-center'>CHECKLIST</p></div>";
            content += "<div class='row' style='margin: 3px 10%; padding: 2% 0px;'>";
            var datos = localStorage.getItem("formioUser");
            var json = JSON.parse(datos);

            if (json.roles[0] === "5dc44c1b1c9d4400000b5fc5") {
                formio.components[3].defaultValue = "galeria";
                flag = "true";
            } else {
                formio.components[1].defaultValue = "";
                flag = "false";
            }

            formio.components.forEach((panel) => {
                var pan = {};
                if (panel.type === "panel" && (panel.key === "page9" || panel.key === "panel8")) {
                    if (panel.key.includes("page9")) {
                        content += "</div>";
                        panel.components[0].content = content;
                        content += "<div class='col-sm-6 col-md-6 col-lg-6 col-xl-6'><p>";
                        content += "<span class='number-menu red-status'>" + count + "</span> ssss" + panel.title;
                        content += "</p></div>";
                        content += "<div class='col-sm-6 col-md-6 col-lg-6 col-xl-6'>";
                        content += "<p id='verify-" + count + "'></p>";
                        content += "</div>";
                    }
                    pan["nombre"] = panel.key;
                    pan["status"] = false;
                    panfinal.push(pan);
                    count++;
                } else if (panel.type === "panel" && (panel.conditional.show == "" || panel.conditional.show == flag)) {
                    content += "<div class='col-sm-6 col-md-6 col-lg-6 col-xl-6'><p>";
                    content += "<span class='number-menu red-status'>" + count + "</span> " + panel.title;
                    content += "</p></div>";
                    content += "<div class='col-sm-6 col-md-6 col-lg-6 col-xl-6'>";
                    content += "<p id='verify-" + count + "'></p>";
                    content += "</div>";
                    panel.title = "<span class='number-menu red-status'>" + count + "</span>" +
                    panel.title;
                    pan["nombre"] = panel.key;
                    pan["status"] = false;
                    panfinal.push(pan);
                    count++;
                }
            });

            context.flag = flag;
            context.pageList = panfinal;
            return [formio.components, panfinal];
        });

        const convocatoria = await new Formio(config.forms.convocatoria).loadSubmissions({
            params: { "data.estado": "activo" },
        });

        context.activeConvocatoria = convocatoria.shift();

        const convocatoriaAnterior = await new Formio(config.forms.convocatoria).loadSubmissions({
            params: {
                "data.estado": "inactivo",
                "limit": "1",
                "sort": "-data.desde"
            },
        });

        context.convocatoriaAnterior = convocatoriaAnterior.shift();

        Formio.createForm(document.getElementById("postulantes"), {
            components: componente[0],
            display: "wizard",
        }).then(async function (wizard) {
            let generalData = await context.getDataPostulant();

            let dataActual = context.getLastPostulantByYear(generalData, context.activeConvocatoria.data.ao);
            let dataAnterior = context.getLastPostulantByYear(generalData, context.convocatoriaAnterior.data.ao);

            let lang = localStorage.getItem("lang");

            wizard.icons = "fontawesome";
            wizard.addLanguage("es", lan_es);
            wizard.language = lang;

            if(dataActual){
                context.actualSubmission = dataActual;
                wizard.submission = dataActual;
            }

            if(dataAnterior){
                context.oldSubmission = dataAnterior;
            }

            wizard.on("prevPage", function (submission) {
                context.onPrev(submission);
            });

            wizard.on("nextPage", async function (submission) {
                context.onNext(submission);

                let tipo = localStorage.getItem("formrol");
                let datausr = localStorage.getItem("formioUser");
                var jsondatausr = JSON.parse(datausr);

                wizard.data.idioma = localStorage.getItem("lang");
                wizard.data.emailOwner = jsondatausr.data.email;
                wizard.data.estado = "Editando";
                wizard.data.tipo = tipo;

                if (context.actualSubmission != null) {
                    if (context.actualSubmission.data.panelFieldsetColumnsNombreparamaterialpromocionalydivulgacindeArtboFindeSemana.length == 0 && wizard.data.panelFieldsetColumnsNombreparamaterialpromocionalydivulgacindeArtboFindeSemana.length > 0) {
                        wizard.data.emailSent = "1";
                    } else {
                        wizard.data.emailSent = "0";
                    }
                } else {
                    if (wizard.data.panelFieldsetColumnsNombreparamaterialpromocionalydivulgacindeArtboFindeSemana.length > 0) {
                        wizard.data.emailSent = "1";
                    } else {
                        wizard.data.emailSent = "0";
                    }
                }

                let submissionObject = context.actualSubmission != null ? { _id: context.actualSubmission._id, data: wizard.data } : { data: wizard.data };
                context.actualSubmission = await formio.saveSubmission(submissionObject);
            });

            wizard.on("boton", async function (_submission) {
                let tipo = localStorage.getItem("formrol");
                let datausr = localStorage.getItem("formioUser");
                var jsondatausr = JSON.parse(datausr);

                wizard.data.idioma = localStorage.getItem("lang");
                wizard.data.emailOwner = jsondatausr.data.email;
                wizard.data.estado = "Editando";
                wizard.data.tipo = tipo;

                if (context.actualSubmission != null) {
                    if (
                    context.actualSubmission.data
                        .panelFieldsetColumnsNombreparamaterialpromocionalydivulgacindeArtboFindeSemana
                        .length == 0 &&
                    wizard.data
                        .panelFieldsetColumnsNombreparamaterialpromocionalydivulgacindeArtboFindeSemana
                        .length > 0
                    ) {
                    wizard.data.emailSent = "1";
                    } else {
                    wizard.data.emailSent = "0";
                    }
                } else {
                    if (
                    wizard.data
                        .panelFieldsetColumnsNombreparamaterialpromocionalydivulgacindeArtboFindeSemana
                        .length > 0
                    ) {
                    wizard.data.emailSent = "1";
                    } else {
                    wizard.data.emailSent = "0";
                    }
                }
                let submissionObject =
                    context.actualSubmission != null
                    ? { _id: context.actualSubmission._id, data: wizard.data }
                    : { data: wizard.data };
                formio.saveSubmission(submissionObject).then(function (updated) {
                    var lenguaje = localStorage.getItem("lang");
                    context.actualSubmission = updated;
                    Swal.fire({
                        icon: "success",
                        title:
                            lenguaje == "es"
                            ? "Los cambios han sido guardado."
                            : "The changes were saved.",
                    });
                });
            });

            wizard.on("submit", async function (submission) {
                let tipo = localStorage.getItem("formrol");
                let datausr = localStorage.getItem("formioUser");
                var jsondatausr = JSON.parse(datausr);

                submission.data.idioma = localStorage.getItem("lang");
                submission.data.emailOwner = jsondatausr.data.email;
                submission.data.estado = "Finalizado";
                submission.data.tipo = tipo;

                if (context.actualSubmission != null) {
                    formio.saveSubmission({
                        _id: context.actualSubmission._id,
                        data: submission.data,
                    }).then(function (updated) {
                        context.actualSubmission = updated;
                        setTimeout(() => {
                            context.$router.push("/postulant/pdf/" + updated._id);
                        }, 2000);
                    });
                } else {
                    formio.saveSubmission({
                        data: submission.data,
                    }).then(function (created) {
                        context.actualSubmission = created;
                        setTimeout(() => {
                            context.$router.push("/postulant/pdf/" + created._id);
                        }, 2000);
                    });
                }
            });

            wizard.on("change", function (_change) {
                var panelAct = utils.searchComponents(wizard.form.components, {
                    key: context.pageList[context.pageAct]["nombre"]
                });

                let val = "";
                FormioUtils.eachComponent(panelAct[0].components, (component) => {
                    if (component.input == true && component.validate != undefined) {
                        if (component.validate.required == true) {
                            if (wizard._data[component.key] == "") {
                                val += "-";
                            }
                        }
                    }
                    if (component.type == "datagrid") {
                        FormioUtils.eachComponent(component.components, (datagrid) => {
                            if (wizard._data[component.key]) {
                                var count = wizard._data[component.key].length;
                                if (datagrid.input == true && datagrid.validate != undefined) {
                                    if (datagrid.validate.required == true) {
                                        for (var i = 0; i < count; i++) {
                                            if (wizard._data[component.key][i][datagrid.key] == "") {
                                                val += "-";
                                            }
                                        }
                                    }
                                }
                            }
                            if (datagrid.type == "datagrid") {
                                FormioUtils.eachComponent(datagrid.components, (datagrid2) => {
                                    if (wizard._data[component.key][0][datagrid.key]) {
                                        var count2 = wizard._data[component.key][0][datagrid.key].length;
                                        if (datagrid2.input == true && datagrid2.validate != undefined) {
                                            if (datagrid2.validate.required == true) {
                                                for (var i = 0; i < count2; i++) {
                                                    if (wizard._data[component.key][0][datagrid.key][i][datagrid2.key] == "") {
                                                        val += "-";
                                                    }
                                                }
                                            }
                                        }
                                    }
                                });
                            }
                        });
                    }
                });

                if (val.trim() == "") {
                    let elements = document.querySelectorAll(".red-status");
                    elements.forEach((number) => {
                        if (parseInt(number.innerText) == context.pageAct){
                            number.className = number.className.replace("red", "green");
                        }
                        context.pageList[context.pageAct]["status"] = true;
                    });
                } else {
                    let elements = document.querySelectorAll(".green-status");
                    elements.forEach((number) => {
                        if (parseInt(number.innerText) == context.pageAct) {
                            number.className = number.className.replace("green", "red");
                        }
                        context.pageList[context.pageAct]["status"] = false;
                    });
                }

                var finalizado = 0;
                context.pageList.forEach(function (value, _i) {
                    if (value.status) finalizado++;
                });

                if (finalizado == context.pageList.length - 2) {
                    let elements = document.querySelectorAll(".red-status");
                    elements.forEach((number) => {
                        if (parseInt(number.innerText) == context.pageList.length - 1) {
                            number.className = number.className.replace("red", "green");
                        }
                    });
                }
            });

            context.formulario = wizard;
            return wizard;
        }).then(function (test) {
            context.onRender();
            context.mostrar = true;
        });
    },
    methods: {
        onRender() {
        for (var i = 1; i < this.pageList.length - 1; i++) {
            var panelAct = utils.searchComponents(this.formulario.form.components, {
            key: this.pageList[i]["nombre"],
            });
            let val = "";

            FormioUtils.eachComponent(panelAct[0].components, (component) => {
            if (component.input == true && component.validate != undefined) {
                if (component.validate.required == true) {
                if (this.formulario._data[component.key] == "") {
                    val += "-" + component.key;
                }
                }
            }
            if (component.type == "datagrid") {
                FormioUtils.eachComponent(component.components, (datagrid) => {
                if (this.formulario._data[component.key]) {
                    var count = this.formulario._data[component.key].length;
                    if (datagrid.input == true && datagrid.validate != undefined) {
                    if (datagrid.validate.required == true) {
                        for (var i = 0; i < count; i++) {
                        if (
                            this.formulario._data[component.key][i][datagrid.key] ==
                            ""
                        ) {
                            val += "-";
                        }
                        }
                    }
                    }
                }
                if (datagrid.type == "datagrid") {
                    FormioUtils.eachComponent(datagrid.components, (datagrid2) => {
                    if (this.formulario._data[component.key][0][datagrid.key]) {
                        var count2 = this.formulario._data[component.key][0][
                        datagrid.key
                        ].length;
                        if (
                        datagrid2.input == true &&
                        datagrid2.validate != undefined
                        ) {
                        if (datagrid2.validate.required == true) {
                            for (var i = 0; i < count2; i++) {
                            if (
                                this.formulario._data[component.key][0][
                                datagrid.key
                                ][i][datagrid2.key] == ""
                            ) {
                                val += "-";
                            }
                            }
                        }
                        }
                    }
                    });
                }
                });
            }
            });

            if (val == "") {
            let elements = document.querySelectorAll(".red-status");
            elements.forEach((number) => {
                if (parseInt(number.innerText) == i)
                number.className = number.className.replace("red", "green");
                this.pageList[i]["status"] = true;
            });
            } else {
            let elements = document.querySelectorAll(".green-status");
            elements.forEach((number) => {
                if (parseInt(number.innerText) == i)
                number.className = number.className.replace("green", "red");
                this.pageList[i]["status"] = false;
            });
            }
        }
        },
        onNext(changeData) {
        this.pageAct = parseInt(this.pageAct) + 1;
        this.pageList.forEach(function (value, i) {
            if (value.status) {
            let elements = document.querySelectorAll(".red-status");
            elements.forEach((number) => {
                if (parseInt(number.innerText) == i) {
                number.className = number.className.replace("red", "green");
                }
            });
            }
        });

        this.toggleShowButton(changeData.page);
        },
        onPrev(changeData) {
        this.pageAct = parseInt(this.pageAct) - 1;
        this.pageList.forEach(function (value, i) {
            if (value.status) {
            let elements = document.querySelectorAll(".red-status");
            elements.forEach((number) => {
                if (parseInt(number.innerText) == i) {
                number.className = number.className.replace("red", "green");
                }
            });
            }
        });

        this.toggleShowButton(changeData.page);
        },
        submitted(response) {
        if (response.data.submit) {
            setTimeout(() => {
            this.$router.push("/postulant/pdf/" + response._id);
            }, 2000);
        }
        },
        async getDataPostulant() {
            var datos = localStorage.getItem("formioUser");
            var json = JSON.parse(datos);

            return await new Formio(config.forms.formulario).loadSubmissions({
                params: {
                    'owner': json._id,
                    'sort': '-created'
                },
            });
        },
        getLastPostulantByYear(generalResults, convotatoriaAo){
            let finalPostulation = null;
            generalResults.forEach((postulation) => {
                if(postulation?.data?.panelConvocatoria == convotatoriaAo){
                    finalPostulation = postulation;
                }
            });
            return finalPostulation;
        },
        async loadOldGeneralData() {
            const { data } = this.oldSubmission;
            if(data){
                try {
                    const generalDataFields = [
                        "panelFieldsetColumnsNombreparamaterialpromocionalydivulgacindeArtboFindeSemana",
                        "panelFieldsetColumnsPginaweb",
                        "panelFieldsetColumnsColumnsHorariodeaperturaalpblico0002400",
                        "panelFieldsetColumnsColumnsReadeexposicindelespacioexpositivomts2",
                        "panelFieldsetColumnsAodeaperturadelespacioexpositivo",
                        "panelFieldset4ColumnsTelfonodelespacioexpositivo",
                        "panelFieldset4Direccin",
                        "fieldsetFieldset3Directores",
                        "page8Fieldset3DatosdellosresponsablesdesuparticipacinenArtboFeria"
                    ];

                    generalDataFields.forEach((field) => {
                        this.$set(this.formulario.submission.data, field, data[field]);
                    });

                    this.formulario.setValue(this.formulario.submission);

                    Swal.fire({
                        icon: "success",
                        title: "Se han cargado los datos de una convocatoria anterior"
                    });
                } catch (excp){
                    console.error(excp);
                    Swal.fire({
                        icon: "error",
                        title: "Ha ocurrido un error al intentar cargar los datos de una convocatoria anterior, por favor intente de nuevo más tarde."
                    });
                }
            } else {
                Swal.fire({
                    icon: "info",
                    title: "No se encontraron registros para una convocatoria anterior"
                });
            }
        },
        toggleShowButton(page) {
        const btnOldData = document.getElementById("btn-load-old-data");

        if (page == 1) {
            btnOldData.classList.add("active");
        } else {
            btnOldData.classList.remove("active");
        }
        },
    },
};
</script>
